'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagStAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 6.4373e-06C9.33333 -6.06604e-05 18.6667 -5.19546e-05 28 5.51343e-06V20C18.6667 20 9.33333 20 1.8971e-06 20L0 6.4373e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.8971e-06 20H28V13.3333H1.8971e-06V20Z",
          fill: "#2ACB41"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.8971e-06 6.66667H28V5.51343e-06L0 6.4373e-06L1.8971e-06 6.66667Z",
          fill: "#2ACB41"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.8971e-06 13.3333H28V6.66667H1.8971e-06V13.3333Z",
          fill: "#FDD043"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.4373e-06L10.6667 10L1.8971e-06 20L0 6.4373e-06Z",
          fill: "#E71E43"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.6667 11.0933L13.0992 12.1574L13.6268 10.3379L12.1305 9.17596L14.024 9.11548L14.6667 7.33333L15.3093 9.11548L17.2028 9.17596L15.7065 10.3379L16.2341 12.1574L14.6667 11.0933Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.3333 11.0933L19.7659 12.1574L20.2935 10.3379L18.7972 9.17596L20.6907 9.11548L21.3333 7.33333L21.976 9.11548L23.8695 9.17596L22.3732 10.3379L22.9008 12.1574L21.3333 11.0933Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagStAsset = forwardRef(FlagStAsset);

export { VpFlagStAsset as default };
